<template>
  <ul class="term-chips ui-font" v-if="status == 'success'">
    <li
      class="inline-block bg-lightest-gray mr-4 p-2 px-4 rounded-full text-sm mb-4"
      v-for="term in terms"
      :key="term.id"
    >
      <router-link :to="getLink(term)">
        {{ term.name }}
      </router-link>
    </li>
  </ul>
  <ul v-else>
    <li
      v-for="i in 4"
      :key="i"
      class="inline-block mr-4 mb-4 h-9 w-28 bg-lightest-gray rounded-full animate-pulse"
    ></li>
  </ul>
</template>

<script>
import Util from "@/lib/Util";

export default {
  name: "TermChips",
  props: {
    terms: Array,
    status: String,
  },
  setup() {
    const getLink = (term) => Util.getTermLink(term);

    return {
      getLink,
    };
  },
};
</script>
